import { MRT_ColumnDef } from 'material-react-table'
import { ReactElement } from 'react'
import { IShipment } from './interfaces'
import SimpleMRTTable from '../../Common/SimpleTableNonInfinite'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { IconButton } from '@mui/material'

interface IShipmentListingGuest {
    shipments: IShipment[]
    isLoading: boolean
}
const ShipmentListingGuest = (props: IShipmentListingGuest): ReactElement => {
    const { shipments } = props
    const { t } = useTranslation()
    const navigate = useNavigate()
    const columns: MRT_ColumnDef<IShipment>[] = [
        {
            accessorKey: 'shipmentName',
            header: t('shipmentName'),
        },
        {
            accessorKey: 'shipmentStatus',
            header: t('shipmentStatus'),
        },
    ]

    const onClickPreview = (row: any) => {
        navigate(`/guestUser/shipment/${row.original?.shipmentId}`, {
            state: { shipment: row.original },
        })
    }

    const renderRowActions = ({ row }: { row: any }) => {
        return (
            <IconButton
                onClick={() => onClickPreview(row)}
                aria-controls="simple-preview"
                aria-haspopup="true"
            >
                <img
                    src="/assets/images/icons/preview.svg"
                    alt={t('Preview')}
                />
            </IconButton>
        )
    }

    return (
        <SimpleMRTTable
            data={shipments}
            columns={columns}
            enableRowActions={true}
            renderRowActions={renderRowActions}
            isLoading={props.isLoading}
        />
    )
}

export default ShipmentListingGuest
